import NiotaClassicApiService from '@/services/niotaClassicApiService';
import debounce from 'lodash/debounce';
import listMixin from '@/components/niotaClassic/listMixin';
import { userItemsPerListMixin, isCopyToClipboardSupported, copyToClipboard } from '@/utils/vuex';
import get from 'lodash/get';
import { mapGetters } from 'vuex';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'NiotaClassicDevicesListsList',
  mixins: [listMixin, userItemsPerListMixin],
  props: {
    selectedAccounts: {
      type: Array,
      required: false,
      default: undefined
    }
  },
  data: function () {
    return {
      lastSearch: '',
      isInitialSearch: false,
      disableFetchOnCreatedMixin: true,
      tableOptions: {
        ...defaultTableOptions
      },
      selected: [],
      deleteFromActility: false,
      isActility: false,
      device: null,
      operationalStatus: {
        0: this.$i18n_t('NiotaClassic.Devices.form.unset'),
        1: this.$i18n_t('NiotaClassic.Devices.form.inTransit'),
        2: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$i18n_t('NiotaClassic.Devices.form.inOperation'),
        4: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      },
      expanded: []
    };
  },
  computed: {
    ...mapGetters({
      sessionUserId: 'authentication/userId'
    }),
    tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('NiotaClassic.Common.table.id'),
          value: 'id',
          align: 'right',
          width: 70
        }, {
          text: '',
          value: 'image',
          sortable: false,
          width: 40
        }, {
          text: this.$i18n_t('NiotaClassic.Devices.table.name'),
          value: 'title'
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.eui'),
          value: 'eui'
        }, {
          text: this.$i18n_t('NiotaClassic.Devices.table.originator'),
          value: 'originator'
        },
        // {
        //   text: this.$i18n_t('NiotaClassic.Devices.table.application'),
        //   value: 'application',
        // },
        // {
        //   text: this.$i18n_t('NiotaClassic.Devices.table.threshold'),
        //   value: 'threshold',
        // },
        {
          text: this.$i18n_t('NiotaClassic.Devices.table.operationalStatus'),
          value: 'operationalStatus'
        },
        // {
        //   text: this.$i18n_t('NiotaClassic.Common.table.createdAt'),
        //   value: 'createdAt',
        // },
        {
          text: '',
          value: 'actions',
          sortable: false,
          width: '78'
        }],
        tableFooterProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, defaultItemsPerPage, 20, 50]
        }
      };
    }
  },
  watch: {
    selectedAccounts: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }
      this.fetchList();
      this.updateAccountParams();
    }, 500)
  },
  created() {
    const page = parseInt(this.$route.query.page, 10) || defaultTableOptions.page;
    const search = this.$route.query.search || '';
    if (search) {
      this.isInitialSearch = true;
      this.searchItem = search;
    }
    this.tableOptions.page = page;
  },
  methods: {
    updatePagination(e) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          ...{
            page: e.page || defaultTableOptions.page
          },
          ...{
            perPage: e.itemsPerPage || defaultTableOptions.itemsPerPage
          }
        }
      }).catch(error => {
        console.error(error);
      });
    },
    updateAccountParams() {
      this.$router.replace({
        query: {
          ...this.$route.query,
          ...{
            accounts: this.getAccountIds(this.selectedAccounts).join(',') || undefined
          }
        }
      }).catch(error => {
        console.error(error);
      });
    },
    updateSearchParams(searchTerm) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          ...{
            search: searchTerm || undefined
          } // set to undefined on empty string to remove from query params
        }
      }).catch(error => {
        console.error(error);
      });
    },
    fetchList() {
      if (this.isFetching) {
        return;
      }
      this.isFetching = true;
      const trimmedSearch = (this.searchItem || '').trim();
      if (this.lastSearch !== trimmedSearch) {
        this.selected = [];
        this.lastSearch = trimmedSearch;
        if (!this.isInitialSearch) {
          this.tableOptions = {
            ...this.tableOptions,
            page: 1
          };
        }
        this.isInitialSearch = false;
      }
      const {
        sortBy,
        sortDesc,
        page,
        itemsPerPage
      } = this.tableOptions;
      const sortItem = sortBy && sortBy.length ? sortBy[0] : 'createdAt';
      const doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      const sortDirection = doSortDesc ? 'DESC' : 'ASC';
      const usedPage = Math.max(1, page || 1);
      const usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      let promise = undefined;
      if (trimmedSearch) {
        this.updateSearchParams(trimmedSearch);
        if (!this.selectedAccounts.length) {
          promise = NiotaClassicApiService.devicesFind(trimmedSearch, usedPage, usedItemsPerPage, sortItem, sortDirection);
        } else {
          promise = NiotaClassicApiService.devicesFindByAccount(this.getAccountIds(this.selectedAccounts), trimmedSearch, usedPage, usedItemsPerPage, sortItem, sortDirection);
        }
      } else {
        this.updateSearchParams('');
        if (!this.selectedAccounts.length) {
          promise = NiotaClassicApiService.devicesFetch(usedPage, usedItemsPerPage, sortItem, sortDirection);
        } else {
          promise = NiotaClassicApiService.devicesFetchByAccount(this.getAccountIds(this.selectedAccounts), usedPage, usedItemsPerPage, sortItem, sortDirection);
        }
      }
      promise.then(res => {
        this.list = res.data.devices;
        this.serverItemsLength = res.pagination.itemCount;
      }).catch(error => {
        console.error('Error fetching devices', error);
      }).finally(() => {
        this.isFetching = false;
      });
    },
    enterSelect(rows) {
      this.$emit('enterSelect', rows);
    },
    handleClickDevice(item) {
      this.$router.push(`/niota-classic/devices/${item.id}/details`);
    },
    deleteFromRemote(remove) {
      this.deleteFromActility = remove;
    },
    async showDeletePrompt(item) {
      await this.fetchDevice(item.id);
      this.selectedItem = item;
      this.deletePrompt = true;
    },
    /** closeDeletePrompt in listMixin */
    deletePromise() {
      if (this.deleteFromActility) {
        return NiotaClassicApiService.deviceDeleteFromActility(this.selectedItem.id);
      } else {
        return NiotaClassicApiService.deviceDelete(this.selectedItem);
      }
    },
    fetchDevice(id) {
      return NiotaClassicApiService.deviceGetDetails(id).then(res => {
        this.device = res.data.device;
        this.isActility = (get(this.device, 'originator.type') || '').toLowerCase() === 'actility';
      }).catch(() => {
        this.device = null;
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.notFound'), 'error');
      });
    },
    isCopySupported() {
      return isCopyToClipboardSupported();
    },
    copyToClipboard(event, copyValue) {
      event.stopPropagation();
      copyToClipboard(copyValue);
    },
    getStatus(status) {
      return this.operationalStatus[status.value];
    },
    getAccountIds(accounts) {
      let ids = [];
      accounts.forEach(account => {
        ids.push(account.id);
      });
      return ids;
    },
    setCurrentTablePage(value) {
      this.tableOptions.page = value;
    }
  }
};